






















































import { Vue, Component } from 'vue-property-decorator';

import StarIcon from './starIcon.vue';
import {
    getSmartSummaryPermission,
    getSmartSummarySwitch,
    getSmartSummaryPrompt,
    updateSmartSummaryPrompt,
    testSmartSummary,
    updateSmartSummarySwitch
} from '@/api/cti';

@Component({
    components: {
        StarIcon
    }
})
export default class extends Vue {
    /** 当前用户是否有权限查看智能概括. */
    hasPermission = false;
    /** 是否开启智能概括. */
    isSwitchOn = false;

    models = [{ label: 'LongCat-Flash-Chat-Eco', value: 'LongCat-Flash-Chat-Eco' }];
    selectedModel = 'LongCat-Flash-Chat-Eco';

    promptContent = '';
    testContent = '';
    summaryContent = '';

    private rgId: number | undefined;
    private isPromptContentSaved = false;

    async created() {
        this.initRgId();
        await this.initPermission();
        await this.initPromptContent();
        await this.initSwitch();
    }

    async handleSwitchChange(b: boolean) {
        const switchValue = b ? 'on' : 'off';
        try {
            await updateSmartSummarySwitch({ rgId: this.rgId, status: switchValue });
        } catch (_) {}
    }

    async handlePromptContentChange() {
        this.isPromptContentSaved = false;
    }

    async updatePromptContent() {
        try {
            const { code } = await updateSmartSummaryPrompt({ rgId: this.rgId, model: this.selectedModel, promptText: this.promptContent });
            if (code === 200) {
                this.isPromptContentSaved = true;
                this.$mtd.message.success('设置保存成功');
            } else {
                this.$mtd.message.error('设置保存失败');
            }
        } catch (_) {
            this.$mtd.message.error('设置保存失败');
        }
    }

    async excuteTest() {
        try {
            const { code, data } = await testSmartSummary({
                rgId: this.rgId,
                model: this.selectedModel,
                promptText: this.promptContent,
                testContent: this.testContent
            });
            if (code === 200) {
                this.summaryContent = data.summaryContent;
                this.$mtd.message.success('测试成功');
            } else {
                this.$mtd.message.error('测试失败');
            }
        } catch (_) {
            this.$mtd.message.error('测试失败');
        }
    }

    get isPromptContentEmpty() {
        return this.promptContent.trim() === '';
    }

    get isTestContentEmpty() {
        return this.testContent.trim() === '';
    }

    get isSummaryContentEmpty() {
        return this.summaryContent.trim() === '';
    }

    get promptContentBackgroundColor() {
        return this.isPromptContentSaved ? '#f8f8f8' : '#fff';
    }

    private initRgId() {
        this.rgId = parseInt(this.$route.query.rgId as string, 10);
    }

    private async initPermission() {
        try {
            const { code } = await getSmartSummaryPermission({ rgId: this.rgId });
            if (code === 200) {
                this.hasPermission = true;
            }
        } catch (_) {}
    }

    private async initSwitch() {
        try {
            const { code, data } = await getSmartSummarySwitch({ rgId: this.rgId });
            if (code === 200) {
                this.isSwitchOn = data.status === 'on';
            }
        } catch (_) {}
    }

    private async initPromptContent() {
        try {
            const { code, data } = await getSmartSummaryPrompt({ rgId: this.rgId });
            if (code === 200) {
                this.promptContent = data.promptText;
                this.selectedModel = data.model;
                this.isPromptContentSaved = !this.isPromptContentEmpty;
            }
        } catch (_) {}
    }
}
